// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --dark-grey-color: #706d6d;
  --darkest-grey-color: #4c4c4c;
  --light-grey-color: #aaaaaa;
  --lightest-grey: #c1c1c1;
  --black-text: #282020;
  --light-black-text: #5b5555;
  --success: #28a745;
  --danger: #dc3545;
  --border-color: #dcdcdc;
  --line-color: #e2e2e2;
}

.left-section {
  color: var(--dark-grey-color);
}

.left-section .section-heading {
  color: black !important;
  margin-bottom: 1em;
}

.order-details-section-container,
.all-appointments-section-container,
.payment-status-section-container {
  background: white;
  padding: 0.7em;
  border: 0.5px solid var(--border-color);
  border-radius: 8px;
}

.success-payment {
  border: 2px solid var(--success);
}
.danger-payment {
  border: 2px solid var(--danger);
}

.Order-details_order-num,
.Order-details_quantity {
  display: flex;
  flex-direction: column;
}

.order-num_heading,
.quantity_heading {
  font-size: 12px;
  color: var(--light-grey-color) !important;
}

.total-amount_heading {
  font-size: 12px;
  color: var(--light-black-text) !important;
}

.left-section-container-lines {
  margin: 0.3rem 0;
  color: var(--line-color) !important;
}

.order-num_number {
  color: var(--dark-grey-color);
  font-weight: 400;
}

.appointment-action-btns {
  color: var(--darkest-grey-color);
  font-weight: 400;
  cursor: pointer;
}

.total-amount_number {
  color: var(--black-text);
  font-weight: 500;
}

h6 {
  font-weight: 500;
  margin-top: 0.5rem !important;
}

.all-appointments_dates {
  color: #999999;
  font-weight: 400;
  font-size: 14px;
}

/* Mid section of booking details */
.appointment-detail-section {
  height: 100vh;
  overflow: auto;
  padding-bottom: 1em;
  width: 98% !important;
}

.appointment-detail-container {
  border: 0.5px solid var(--border-color);
  height: 100vh !important;
  background: white;
  border-radius: 10px;
  padding-bottom: 65px !important;
  overflow-y: auto;
}

.appointment-time {
  color: var(--black-text);
  text-align: center;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
}

.appointment-service-name_flex {
  display: flex;
  justify-content: space-between;
  align-self: center;
}

.appointment-service-name_holder {
  text-align: left;
  text-transform: capitalize;
}

.appointment-service-name_holder span {
  font-weight: 500;
}

.appointment-service-name_holder .col-dark-gray {
  font-weight: 400;
}

.horizontal-line_appointment {
  color: var(--line-color);
  margin: 15.6px 0 21.4px;
}

.size-sml {
  font-size: 12px;
}

.appointment-details {
  font-size: 15px;
  color: #443f3f;
  font-weight: 400;
}

.appointment-attribute-prive {
  color: #aaa;
}
.col-dark-gray {
  color: var(--lightest-grey);
}

.provider-details {
  width: 30px;
  height: 30px;
  margin: 1px 10px 2px 0;
  border-radius: 8px;
}

.provider-name {
  font-size: 15px;
  color: #443f3f;
  text-transform: capitalize;
  font-weight: 400;
}

.cursor-pointer {
  cursor: pointer;
}

.appointment-details_attributes {
  font-size: 12px;
  color: var(--light-grey-color);
  font-weight: 400;
}

.check-in-btn {
  text-transform: capitalize !important;
  width: 100% !important;
  background-color: #f5bf00 !important;
  color: white !important;
  height: 45px !important;
  border-radius: 5px !important;
}

.non-capitalized {
  text-transform: none !important;
}

.appointment-status-dropdown {
  border: none;
  width: 100%;
  padding-top: 0.3em;
}

.appointment-status-dropdown:focus-visible {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/Calendar/scheduler/AppointmentDetails/appointmentDetails.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;EACjB,cAAc;EACd,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;EACtB,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf","sourcesContent":[":root {\n  --dark-grey-color: #706d6d;\n  --darkest-grey-color: #4c4c4c;\n  --light-grey-color: #aaaaaa;\n  --lightest-grey: #c1c1c1;\n  --black-text: #282020;\n  --light-black-text: #5b5555;\n  --success: #28a745;\n  --danger: #dc3545;\n  --border-color: #dcdcdc;\n  --line-color: #e2e2e2;\n}\n\n.left-section {\n  color: var(--dark-grey-color);\n}\n\n.left-section .section-heading {\n  color: black !important;\n  margin-bottom: 1em;\n}\n\n.order-details-section-container,\n.all-appointments-section-container,\n.payment-status-section-container {\n  background: white;\n  padding: 0.7em;\n  border: 0.5px solid var(--border-color);\n  border-radius: 8px;\n}\n\n.success-payment {\n  border: 2px solid var(--success);\n}\n.danger-payment {\n  border: 2px solid var(--danger);\n}\n\n.Order-details_order-num,\n.Order-details_quantity {\n  display: flex;\n  flex-direction: column;\n}\n\n.order-num_heading,\n.quantity_heading {\n  font-size: 12px;\n  color: var(--light-grey-color) !important;\n}\n\n.total-amount_heading {\n  font-size: 12px;\n  color: var(--light-black-text) !important;\n}\n\n.left-section-container-lines {\n  margin: 0.3rem 0;\n  color: var(--line-color) !important;\n}\n\n.order-num_number {\n  color: var(--dark-grey-color);\n  font-weight: 400;\n}\n\n.appointment-action-btns {\n  color: var(--darkest-grey-color);\n  font-weight: 400;\n  cursor: pointer;\n}\n\n.total-amount_number {\n  color: var(--black-text);\n  font-weight: 500;\n}\n\nh6 {\n  font-weight: 500;\n  margin-top: 0.5rem !important;\n}\n\n.all-appointments_dates {\n  color: #999999;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n/* Mid section of booking details */\n.appointment-detail-section {\n  height: 100vh;\n  overflow: auto;\n  padding-bottom: 1em;\n  width: 98% !important;\n}\n\n.appointment-detail-container {\n  border: 0.5px solid var(--border-color);\n  height: 100vh !important;\n  background: white;\n  border-radius: 10px;\n  padding-bottom: 65px !important;\n  overflow-y: auto;\n}\n\n.appointment-time {\n  color: var(--black-text);\n  text-align: center;\n  font-family: \"Poppins\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n}\n\n.appointment-service-name_flex {\n  display: flex;\n  justify-content: space-between;\n  align-self: center;\n}\n\n.appointment-service-name_holder {\n  text-align: left;\n  text-transform: capitalize;\n}\n\n.appointment-service-name_holder span {\n  font-weight: 500;\n}\n\n.appointment-service-name_holder .col-dark-gray {\n  font-weight: 400;\n}\n\n.horizontal-line_appointment {\n  color: var(--line-color);\n  margin: 15.6px 0 21.4px;\n}\n\n.size-sml {\n  font-size: 12px;\n}\n\n.appointment-details {\n  font-size: 15px;\n  color: #443f3f;\n  font-weight: 400;\n}\n\n.appointment-attribute-prive {\n  color: #aaa;\n}\n.col-dark-gray {\n  color: var(--lightest-grey);\n}\n\n.provider-details {\n  width: 30px;\n  height: 30px;\n  margin: 1px 10px 2px 0;\n  border-radius: 8px;\n}\n\n.provider-name {\n  font-size: 15px;\n  color: #443f3f;\n  text-transform: capitalize;\n  font-weight: 400;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.appointment-details_attributes {\n  font-size: 12px;\n  color: var(--light-grey-color);\n  font-weight: 400;\n}\n\n.check-in-btn {\n  text-transform: capitalize !important;\n  width: 100% !important;\n  background-color: #f5bf00 !important;\n  color: white !important;\n  height: 45px !important;\n  border-radius: 5px !important;\n}\n\n.non-capitalized {\n  text-transform: none !important;\n}\n\n.appointment-status-dropdown {\n  border: none;\n  width: 100%;\n  padding-top: 0.3em;\n}\n\n.appointment-status-dropdown:focus-visible {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
